export const basePath =
  "https://api.stickwellpapers.com/api/";
export const basePathForStorage =
  "https://api.stickwellpapers.com/storage/";
